import React, { useEffect } from "react";
import { Routes, Route, Outlet,useLocation } from "react-router-dom";
import FlowBuilder from "../FlowBuilder/FlowBuilder";
import "./Create.css";
import CircularProgress from "@mui/material/CircularProgress";
import {
  createClientApi,
  createEnvApi,
} from "../../apis/createEnvApi/createEnvApi";
import { useDispatch, useSelector } from "react-redux";
import {
  createDeployment,
  createFlow,
  getDefaultFlow,
  getRNData,
  triggerTerraFormPipeline,
} from "../../apis/flowBuilderApi/flowBuilderApi";
import Spinner from "../../layouts/spinner/Spinner";


const CreateClient=()=>{
  const propsData= useLocation().state;
  const [loading, setLoading] = React.useState(false);
  const [showCreateClientDiv, setShowCreateClientDiv] = React.useState(true);
  const [showCreateEnvDiv, setShowCreateEnvDiv] = React.useState(true);
  const [showCreateFlowDiv, setShowCreateFlowDiv] = React.useState(false);
  const [clientName, setClientName] = React.useState("");
  const [clientId, setClientId] = React.useState<any>();
  const [envId, setEnvId] = React.useState<any>();
  const [clientDesc, setClientDesc] = React.useState("");
  const [envName, setEnvName] = React.useState("");
  const [envList, setEnvList] = React.useState<any>([]);
  const [envDesc, setEnvDesc] = React.useState("");
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const [createdEnvList, setCreatedEnvList] = React.useState<any>([]);
  const [createdClientData, setCreatedClientData] = React.useState<any>([]);
  const [appRNData, setAppRNData] = React.useState<any>([]);
  // const plusIcon = "fas fa-circle-plus";
  const insertData=useSelector((state:any)=>state.flowBuilder.insertData);
  useEffect(() => {
    addNewEnv(EmpId);
      const RN_payload ={
          "includeTerraformGeneratedKey": "N"
        }
        setLoading(true);
        getRNData(RN_payload,(res: any) => {
          setAppRNData(res);
          setLoading(false);
        });
  }, []);



  const handleEnvNameChange = (value: any, i: any) => {
    const newEnvList = envList.map((env: any, index: any) => {
      if (index === i) {
        let newEnv = env;
        newEnv.Env_Type = value;
        let x = Math.floor(Math.random() * 100 + 1);
        newEnv.Env_Nm = value + x.toString();
        return newEnv;
      } else {
        return env;
      }
    });
    setEnvList(newEnvList);
  };

  const handleEnvDescChange = (value: any, i: any) => {
    const newEnvList = envList.map((env: any, index: any) => {
      if (index === i) {
        let newEnv = env;
        newEnv.Env_Dsc = value;
        return newEnv;
      } else {
        return env;
      }
    });
    setEnvList(newEnvList);
  };

  const addNewEnv = (newclient_Id?: any) => {
    let newEnvList = envList.map((env: any, index: any) => {
      return env;
    });
    let payload = {
      Env_Type: "",
      Env_Nm: "",
      Env_Dsc: "",
    };
    newEnvList.push(payload);
    setEnvList(newEnvList);
  };

  // const handleCreateClient=(event:any)=>{
  //   event.preventDefault();
  //   setLoading(true);
  //   let payload={
  //     "Client_Nm": clientName,
  //     "Client_Dsc": clientDesc,
  //     "CreatedBy_Id": EmpId,
  //     "UpdatedBy_Id": EmpId
  //   }
  //   createClientApi(payload,(res:any)=>{
  //     setClientId(res[0].Client_Id);
  //     setLoading(false);
  //     setShowCreateClientDiv(false);
  //     addNewEnv(res[0].Client_Id);
  //     setShowCreateEnvDiv(true);
  //   })
  // }

  const handleCreateEnv = (event: any) => {
    event.preventDefault();
    setLoading(true);
    let payload = {
      Client_Nm: propsData?propsData.Client_Name:clientName,
      Client_Dsc: clientDesc,
      CreatedBy_Id: EmpId,
      UpdatedBy_Id: EmpId,
      Env_Data: envList,
      Client_Id:propsData?propsData.Client_Id:""
    };
    console.log("handleCreateEnv--->", payload);
    createEnvApi(payload, (res: any) => {
      if(res){
        let response = res;
        response.createFlag = true;
        setCreatedClientData(response);
  
        //get RN data
        const RN_payload ={
          "includeTerraformGeneratedKey": "N"
        }
        getRNData(RN_payload,(res: any) => {
          setAppRNData(res);
  
          //show App flow Builder
          setLoading(false);
          setShowCreateEnvDiv(false);
          setShowCreateFlowDiv(true);
        });
  
      }
      else{
        window.alert('This name already exist.')
      }
          });
  };
  const handleCreateAppFlow = (data: any) => {

    let insertCopy=data.insertData?data.insertData:[]
    insertCopy=insertCopy.concat(data.flowData.map(((e:any)=>{return {
      Field_Id:e.nodeId,
      Field_Type:e.type,
      value:'',
      FB_Id:e.fbId,
      sortOrder:e.sortOrder
    }})))
    let payload = {
      Flow_Builder_Object: data.flowData,
      Insert_Data:insertCopy
    };
    console.log("handle create flow --->", payload ,data);
    //console.log(JSON.stringify(payload.Insert_Data))
    //////payload={"Client_Id":1401,"Env_Id":1526,"Flow_Builder_Object":[{"sortOrder":1,"name":"Preferences","fbId":"node-9b3e60b4-04c7-466d-b8d6-e8c74cc3855a","nodeId":1006,"parentId":1000,"type":"condition","data":{"displayName":"Preferences","Deployment":"N","Communication_Service_Provider":"Twilio","Authentication_Type":"AD","Profile":"Y","Rep":"Y","Mobile":"Y"}},{"sortOrder":2,"name":"Client Details","fbId":"node-ab9cd25f-880b-403a-8548-d2f71749ef3b","nodeId":1007,"parentId":1006,"type":"condition","data":{"displayName":"Client Details","service_connection":"P360 Deployment","azure_tenant_id":"2f267b42-7074-43d7-927f-6cd5c2ba4275","azure_client_id":"41849a13-563e-45e0-a00f-87aa51f9f638","azure_client_secret":"o~a8Q~MrxtfoS8Qbccmx0mCI1SRIByhDXhTdlbwP","react_app_zing_domain_url":"https://zingd.p360zing.com","react_app_zing_domain":"zingd","react_app_ad_clientid":"dd935cbb-2ddc-4766-8be3-2455b5b2234f","react_app_ad_redirect_url":"https://zingd.p360zing.com","react_app_android_redirect_uri":"https://zingd.p360zing.com","react_app_auth_session_validity_minute":"5","react_app_date_banner_bg_color":"#0000FF","react_app_default_country":"US","react_app_zing_placeholder_text_color":"#0000FF","service_location":"centralus","phone_override_check":"true","react_app_auth_session_timeout_enabled":"true","react_app_avatar_with_icon":"Y","react_app_enable_hospital_contact":"false","react_app_is_cross_platform":"false","react_app_show_info_btn":"Y","react_app_show_message_avatar":"Y","react_app_show_message_status_icon":"Y","react_app_show_message_status_text":"Y","react_app_sms_icon":"Y","rg_name":"ZingSaaSV3"}},{"sortOrder":3,"name":"Env","fbId":"node-292c0e8e-a691-496d-9014-d359a93b6b23","nodeId":1008,"parentId":1007,"type":"condition","data":{"displayName":"Env","auth_logger_email_to":"parag.khursange@p360.com","pusher_app_id":"1709648","pusher_cluster":"ap2","pusher_key":"7f0f95cc5145517e98bd","pusher_secret":"5aaaf4c75e3651ccd238","react_app_logo":"https://p360zingbaseappuat.blob.core.windows.net/logo/logo.png","react_app_main_app_css_secondary_bg_color":"#FFC0CB","react_app_ph_override_msg":"Override","react_app_title":"ZingD","react_app_zing_primary_color":"#cc333a","react_app_zing_primary_text_color":"#2e0020","react_app_zing_secondary_color":"#1100ff","react_app_zing_secondary_text_color":"#2e0020","react_app_zing_tertiary_color":"#2e0020","twilio_account_authtoken":"ce998bcfb688d0c19614eb4fd793744b","twilio_account_sid":"AC1ce8e56c9b9fcbbd4bbd06351c8a8531","twilio_twilioapikey":"SK2213239e5e95b7e1d660ab135bd49743","twilio_twilioapisecret":"NUlFC7VLZIvsNM8hKQjYjJwR94t9SoMD","twilio_twiml_app_sid":"APd2434aaf2e2dc1168b54b53f7919159f","twilio_voice_api_key":"SK2213239e5e95b7e1d660ab135bd49743","twilio_voice_api_secret":"NUlFC7VLZIvsNM8hKQjYjJwR94t9SoMD","react_app_abs_approved":"Y","react_app_abs_config_showbanner":"N","react_app_rem_cntry_cd_input":"Y","react_app_rem_cntry_cd_text":"Y","react_app_should_show_contact_pickup":"Y","react_app_mobile_bottom_nav_flag":"Y","react_app_should_use_face_lock":"N","react_app_profile_qr":"Y","react_app_autopilot_flag":"Y","react_app_multi_pres_association":"Y"}},{"sortOrder":4,"name":"Message","fbId":"node-bfec626e-ea87-461e-a996-ef0714f58bfb","nodeId":1009,"parentId":1008,"type":"condition","data":{"displayName":"Message","event_hub_maximum_retry":"3","message_timer_wa_optin":"20","national_helpline_number":"1234567896","react_app_ooo_message_type":"OOO","react_app_ooo_type":"TOGGLE","vcf_verbiage":"Here is your VCF card","zing_url_shorturl_api_key":"28bfd3f118ed457daa1136e64a68187b","zing_url_shorturl_endpoint":"https://zing-saas-content-moderator.cognitiveservices.azure.com/contentmoderator/moderate/v1.0/ProcessText/Screen?classify=True","twilio_help_message":"Help","twilio_opt_in_message":"Optin","twilio_opt_out_message":"Optout","content_moderator_flag":"Y","intro_required":"true","need_vcf_as_link":"true","react_app_abs_chat_fetch":"Y","react_app_abs_config_allowchat":"Y","vcf_separate_attach":"false","react_app_attachment_enabled":"true","react_app_besttime_flag":"true"}},{"sortOrder":5,"name":"Call","fbId":"node-b9c18a4b-a775-4515-a41a-d27fc0cf8b28","nodeId":1010,"parentId":1008,"type":"condition","data":{"displayName":"Call","default_voice_mail_message":"Please hold on i am calling ","react_app_show_bridgecall_callmodal":"Y","react_app_show_bridgecall_profilesidebar":"N"}}],"Insert_Data":[{"Field_Id":1284,"Field_Type":"radio","value":1289,"FB_Id":"node-f6e89e91-9c2b-4d60-8ff2-3abf67af619b"},{"Field_Id":1286,"Field_Type":"dropdown","value":1292,"FB_Id":"node-f6e89e91-9c2b-4d60-8ff2-3abf67af619b"},{"Field_Id":1294,"Field_Type":"dropdown","value":1303,"FB_Id":"node-f6e89e91-9c2b-4d60-8ff2-3abf67af619b"},{"Field_Id":1297,"Field_Type":"radio","value":1299,"FB_Id":"node-f6e89e91-9c2b-4d60-8ff2-3abf67af619b"},{"Field_Id":1305,"Field_Type":"radio","value":1306,"FB_Id":"node-f6e89e91-9c2b-4d60-8ff2-3abf67af619b"},{"Field_Id":1308,"Field_Type":"radio","value":1309,"FB_Id":"node-f6e89e91-9c2b-4d60-8ff2-3abf67af619b"},{"Field_Id":1006,"Field_Type":"condition","value":"","FB_Id":"node-9b3e60b4-04c7-466d-b8d6-e8c74cc3855a","sortOrder":1},{"Field_Id":1007,"Field_Type":"condition","value":"","FB_Id":"node-ab9cd25f-880b-403a-8548-d2f71749ef3b","sortOrder":2},{"Field_Id":1008,"Field_Type":"condition","value":"","FB_Id":"node-292c0e8e-a691-496d-9014-d359a93b6b23","sortOrder":3},{"Field_Id":1009,"Field_Type":"condition","value":"","FB_Id":"node-bfec626e-ea87-461e-a996-ef0714f58bfb","sortOrder":4},{"Field_Id":1010,"Field_Type":"condition","value":"","FB_Id":"node-b9c18a4b-a775-4515-a41a-d27fc0cf8b28","sortOrder":5}]}
      // createFlow(payload, (res: any) => {
      console.log("flow created:::::---::::");
      createDeployment(payload, (resp: any) => {
        // setLoading(false);
        console.log("flow TERRA FORM CREATED:::::---::::", resp);

        // triggerTerraFormPipeline(resp, (res: any) => {
        //   console.log("Trigger TERRA Pipeline::::---::::");
        // });
      // });
    });
  };





  return (
    <>

      {loading && <Spinner
        style={{
          position: 'fixed',
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />}
      {!loading &&
        <FlowBuilder
          load_Flow_Data={false}
          data={createdClientData}
          flowRNData={appRNData}
          handleSubmitFlow={(data: any) => {
            handleCreateAppFlow(data);
          }}
        />
        }
    </>
  );
}

export default CreateClient;
